const config = {
  apiKey: "AIzaSyBqWteGnbNR1fTJW1ntzHeqF-bEcZpErI8",
  authDomain: "soulweb-contact-form.firebaseapp.com",
  databaseURL: "https://soulweb-contact-form.firebaseio.com",
  projectId: "soulweb-contact-form",
  storageBucket: "soulweb-contact-form.appspot.com",
  messagingSenderId: "746230760519",
  appId: "1:746230760519:web:109cc975099a34c5"
};

let firebaseInstance
export const getFirebase = firebase => {
  if (firebaseInstance) {
    return firebaseInstance
  }

  if (!firebase.apps.length) {
    firebase.initializeApp(config)
  }
  else {
    firebase.app();
  }

  firebaseInstance = firebase

  return firebase
}
